import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import CutPrepForm from "@/components/CutPrepForm";

// Per-row production-file dialog for Large Format / Stickers rows (art already uploaded).
export default function CutFileDialog({ open, onOpenChange, row, isSticker = false }) {
  if (!row) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="cutfile-dialog">
        <DialogHeader>
          <DialogTitle className="font-head">Production file · Cut &amp; Bleed</DialogTitle>
          <DialogDescription>Generate a VersaWorks-ready PDF with bleed and a CutContour line from this line's artwork.</DialogDescription>
        </DialogHeader>
        <CutPrepForm
          artId={row.art_id}
          initW={row.width}
          initH={row.height}
          initUnit="in"
          initMode={isSticker ? "kiss_cut" : "shape"}
        />
      </DialogContent>
    </Dialog>
  );
}
